import React from 'react'
import Link from 'gatsby-link'


const NavLink = ({ title, image, href }) => {

  const link__itemActive = {
    background: '#fbfbfb',
    color: '#000',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.14)',
    width: '85%',
    borderRadius: '0 50px 50px 0',
    fontWeight: '700',
    transition: 'all .2s ease'
  }

  const link__item = {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0',
    padding: '8px 40px',
    width: '85%',
    borderRadius: '0 50px 50px 0',
    color: '#888',
    fontSize: '14px',
    transition: 'all .2s ease'
  }

  return (
        <Link style={ link__item } activeStyle={link__itemActive} exact to={href}>
          <img className="source__logo" src={image} />
          {title}
        </Link>
        // <p className="navDesc">Sources</p>
 )
}

export default NavLink



// WEBPACK FOOTER //
// ./src/components/deskNav/navLink.js